import dayjs from "dayjs";

function includeCaseInsensitive(data:any, expValue:any, includes:boolean){
  let dataToQuery;
  let expValueToQuery;
  if( typeof data === "string" ){
    dataToQuery = data.toLowerCase().trim()
  } else if (typeof data === "number"){
    dataToQuery = data.toString()
  } else {
    dataToQuery = data
  }

  if( typeof expValue === "string" ){
    expValueToQuery = expValue.toLowerCase().trim()
  } else if (typeof expValue === "number"){
    expValueToQuery = expValue.toString()
  } else {
    expValueToQuery = expValue
  }

  // console.log(`dataToQuery: ${dataToQuery}`)
  // console.log(`expValueToQuery: ${expValueToQuery}`)

  if( dataToQuery === null || expValueToQuery === null ) return false
  return (includes === true) ? expValueToQuery?.includes(dataToQuery) : !expValueToQuery?.includes(dataToQuery)
}

/*
  data = what comes in from the client api feed
  expValue = the value needed to pass
*/
export function compareData(data:any, expValue:any, operator:string){
  switch(operator){
    case "mustBe":
      return {
        data,
        expValue,
        verdict:
          typeof data === "string" && typeof expValue === "string" 
            ? data.toLowerCase().trim() == expValue.toLowerCase().trim()
            : data == expValue
      }

    case "mustBeNot":
      return {
        data,
        expValue,
        verdict:
        typeof data === "string" && typeof expValue === "string" 
        ? data.toLowerCase().trim() != expValue.toLowerCase().trim()
        : data != expValue
      }

    case "mustBeStrict":
      return {
        data,
        expValue,
        verdict:
        typeof data === "string" && typeof expValue === "string" 
        ? data.toLowerCase().trim() === expValue.toLowerCase().trim()
        : data === expValue
      }

    case "mustNotBeStrict":
      return {
        data,
        expValue,
        verdict:
        typeof data === "string" && typeof expValue === "string" 
        ? data.toLowerCase().trim() !== expValue.toLowerCase().trim()
        : data !== expValue
      }

    case "mustBeGt":
      // console.log(parseInt(data) > parseInt(expValue))
      return {
        data,
        expValue,
        verdict:
          parseInt(data) > parseInt(expValue)
      }

    case "mustBeLt":
      return {
        data,
        expValue,
        verdict:
          parseInt(data) < parseInt(expValue)
      }

    case "mustBeGte":
      return {
        data,
        expValue,
        verdict:
          parseInt(data) >= parseInt(expValue)
      }

    case "mustBeLte":
      return {
        data,
        expValue,
        verdict:
          parseInt(data) <= parseInt(expValue)
      }

    case "mustBeBefore":
      return {
        data,
        expValue,
        verdict:
          dayjs(data).isBefore(dayjs(expValue))
      }

    case "mustBeAfter":
      return {
        data,
        expValue,
        verdict:
          dayjs(data).isAfter(dayjs(expValue))
      }

    case "mustContain":
      return {
        data,
        expValue,
        verdict:
          data.includes(expValue)
      }

    case "mustNotContain":
      return {
        data,
        expValue,
        verdict:
          !data.includes(expValue)
      }

    // the incoming data must include the specified expValue
    case "mustInclude":
      return {
        data,
        expValue,
        verdict:
          includeCaseInsensitive(data, expValue, true)
      }

    case "mustNotInclude":
      return {
        data,
        expValue,
        verdict:
          includeCaseInsensitive(data, expValue, false)
      }

    case "mustExist":
      return {
        data,
        expValue,
        verdict:
          data !== null && data !== undefined && data !== "null" && data !== "undefined"
      }

    case "mustNotExist":
      return {
        data,
        expValue,
        verdict:
          data === null || data === undefined || data === "null" || data === "undefined"
      }

    case "hasObjectWhere":
      const key = expValue.split(":")[0]
      const value = expValue.split(":")[1]
      return {
        data,
        expValue,
        verdict:
          data.find( (item:any) => item[key] === value ) !== undefined && data.find( (item:any) => item[key] === value ) !== null
      }

    case "hasNoObjectWhere":
      const key2 = expValue.split(":")[0]
      const value2 = expValue.split(":")[1]
      return {
        data,
        expValue,
        verdict:
          data.find( (item:any) => item[key2] === value2 ) === undefined || data.find( (item:any) => item[key2] === value2 ) === null
      }
    
    default:
      return {
        data,
        expValue,
        verdict:
          false
      }
  }
}